




















import { Component, Vue, Prop } from "vue-property-decorator";
@Component({})
export default class CdrPatientDetailHeader extends Vue {
  @Prop()
  private patient: any;
  private goBack() {
    this.$router.replace({
      path: "/main/sjzx/zbsjk-list",
    });
  }
}
